module.exports = __webpack_public_path__ + "img/forte1.b702eb6b.jpeg";